module.exports = __webpack_public_path__ + "img/ring_r_e_0_0.59c8ec1f.png";